import React from 'react';
import { useNavigate } from 'react-router-dom';

import { LocalLoginPage } from './LocalLoginPage';
import { localLogin } from '../../../api/localLogin/localLogin';
import { BASE_PATH } from '../../../domain/routes';

export const LocalLoginPageManager = () => {
  const navigate = useNavigate();
  return (
    <LocalLoginPage
      onLogin={async (username: string) => {
        await localLogin(username);
        navigate(BASE_PATH);
      }}
    />
  );
};
